"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFieldSequenceInfo = void 0;
var tree_creator_1 = require("./tree-creator");
function updateFieldSequenceInfo(modelManager, layoutFormatterManager, fieldRequestManager) {
    for (var _i = 0, _a = modelManager.model.mainSubDocument.fields; _i < _a.length; _i++) {
        var field = _a[_i];
        var fieldParser = tree_creator_1.FieldsWaitingForUpdate.getParser(modelManager, layoutFormatterManager, fieldRequestManager, modelManager.model.mainSubDocument, field);
        if (fieldParser)
            fieldParser.updateInfo();
    }
}
exports.updateFieldSequenceInfo = updateFieldSequenceInfo;
